(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header = document.querySelector('[data-sd-header]');
  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 48);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const reveals = document.querySelectorAll('[data-reveal]');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((el) => el.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -45px' });
    reveals.forEach((el) => observer.observe(el));
  }

  document.querySelectorAll('.sd-mobile-menu a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });

  const swipeDemo = document.querySelector('[data-swipe-demo]');
  if (swipeDemo) {
    const cardImages = (swipeDemo.dataset.cardImages || '').split('|');
    const opportunities = [
      { code: 'FEATURE / 01', art: 'THE<br>QUIET<br>NORTH', type: 'FEATURE FILM · ATLANTA', title: 'Maeve — Supporting', desc: 'Character-driven drama · Paid role', location: 'Atlanta, GA', deadline: 'Friday', materials: 'Headshot + reel', union: 'SAG-AFTRA', compensation: 'Paid', imageAlt: 'Cinema camera on a film set, illustrative opportunity image' },
      { code: 'CAMPAIGN / 02', art: 'CITY<br>IN<br>MOTION', type: 'COMMERCIAL CAMPAIGN · NEW YORK', title: 'Featured principal', desc: 'Lifestyle campaign · Digital + print', location: 'New York, NY', deadline: 'Monday', materials: 'Digitals + slate', union: 'Non-union', compensation: 'Paid', imageAlt: 'Model photographed in a studio, illustrative opportunity image' },
      { code: 'SHORT / 03', art: 'AFTER<br>THE<br>RAIN', type: 'INDEPENDENT SHORT · CHICAGO', title: 'Noah — Lead', desc: 'Intimate drama · Paid role', location: 'Chicago, IL', deadline: '5 days', materials: 'Résumé + tape', union: 'Agreement pending', compensation: 'Paid', imageAlt: 'Film crew working on a set, illustrative opportunity image' }
    ];
    const card = swipeDemo.querySelector('[data-swipe-card]');
    const fields = {
      code: swipeDemo.querySelector('[data-card-code]'), art: swipeDemo.querySelector('[data-card-art]'), type: swipeDemo.querySelector('[data-card-type]'),
      title: swipeDemo.querySelector('[data-card-title]'), desc: swipeDemo.querySelector('[data-card-desc]'), location: swipeDemo.querySelector('[data-card-location]'),
      deadline: swipeDemo.querySelector('[data-card-deadline]'), materials: swipeDemo.querySelector('[data-card-materials]'), count: swipeDemo.querySelector('[data-card-count]'),
      union: swipeDemo.querySelector('[data-card-union]'), compensation: swipeDemo.querySelector('[data-card-compensation]')
    };
    const cardImage = swipeDemo.querySelector('[data-card-image]');
    const swipeLabel = swipeDemo.querySelector('[data-swipe-label]');
    let index = 0;
    let startX = 0;
    let currentX = 0;
    let dragging = false;
    const render = () => {
      const item = opportunities[index];
      Object.keys(item).forEach((key) => { if (fields[key]) fields[key][key === 'art' ? 'innerHTML' : 'textContent'] = item[key]; });
      if (cardImage && cardImages[index]) { cardImage.src = cardImages[index]; cardImage.alt = item.imageAlt; }
      fields.count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(opportunities.length).padStart(2, '0')}`;
      card.setAttribute('aria-label', `Fictional opportunity ${index + 1} of ${opportunities.length}: ${item.title}. Drag horizontally or use the buttons below.`);
    };
    const move = (direction) => {
      card.classList.add('is-leaving');
      card.style.transform = `translateX(${direction * 120}px) rotate(${direction * 5}deg)`;
      window.setTimeout(() => {
        index = (index + direction + opportunities.length) % opportunities.length;
        render();
        card.style.transition = 'none'; card.style.transform = 'translateX(0) rotate(0)'; card.classList.remove('is-leaving');
        requestAnimationFrame(() => { card.style.transition = ''; });
      }, reduceMotion ? 0 : 280);
    };
    swipeDemo.querySelectorAll('[data-swipe]').forEach((button) => button.addEventListener('click', () => move(button.dataset.swipe === 'next' ? 1 : -1)));
    card.addEventListener('pointerdown', (event) => { dragging = true; startX = event.clientX; currentX = 0; card.classList.add('is-dragging'); card.setPointerCapture?.(event.pointerId); });
    card.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      currentX = event.clientX - startX;
      card.style.transform = `translateX(${currentX}px) rotate(${currentX / 24}deg)`;
      swipeLabel.style.display = Math.abs(currentX) > 26 ? 'block' : 'none';
      swipeLabel.textContent = currentX > 0 ? 'SAVE' : 'PASS';
      swipeLabel.style.color = currentX > 0 ? '#ead5a3' : '#f2a6a0';
    });
    const endDrag = () => {
      if (!dragging) return;
      dragging = false; card.classList.remove('is-dragging'); swipeLabel.style.display = 'none';
      if (Math.abs(currentX) > 90) move(currentX > 0 ? 1 : -1);
      else card.style.transform = '';
    };
    card.addEventListener('pointerup', endDrag); card.addEventListener('pointercancel', endDrag);
    card.addEventListener('keydown', (event) => { if (event.key === 'ArrowRight') move(1); if (event.key === 'ArrowLeft') move(-1); });
    render();
  }

  const manager = document.querySelector('[data-manager-demo]');
  if (manager) {
    const examples = {
      opportunity: { question: 'I found a role I like. What should I check first?', answer: 'Start with the role requirements and deadline. Then confirm your location, availability, and requested materials before deciding whether to pursue it.', list: ['Review role and production context', 'Check availability and location', 'Confirm headshot, résumé, and reel readiness'] },
      materials: { question: 'Are my materials ready for this opportunity?', answer: 'Use the opportunity requirements as the checklist. Review each requested item for relevance, recency, and completeness before you make a submission decision.', list: ['Match materials to the role', 'Check filenames and current versions', 'Flag anything that still needs attention'] },
      week: { question: 'Help me organize the week ahead.', answer: 'Bring deadlines, audition preparation, profile upkeep, and follow-ups into one view. Then choose the priorities that protect the most time-sensitive work.', list: ['Confirm upcoming deadlines', 'Block preparation time', 'Keep final approval with you'] }
    };
    const question = manager.querySelector('[data-manager-question]');
    const answer = manager.querySelector('[data-manager-answer]');
    const list = manager.querySelector('[data-manager-list]');
    const typing = manager.querySelector('[data-manager-typing]');
    const managerContent = manager.querySelector('[data-manager-content]');
    let managerTimer;
    manager.querySelectorAll('[data-prompt]').forEach((button) => button.addEventListener('click', () => {
      manager.querySelectorAll('[data-prompt]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
      const example = examples[button.dataset.prompt];
      question.textContent = example.question;
      window.clearTimeout(managerTimer);
      if (typing && managerContent && !reduceMotion) { typing.classList.add('is-visible'); managerContent.hidden = true; }
      managerTimer = window.setTimeout(() => {
        answer.textContent = example.answer;
        list.innerHTML = example.list.map((item) => `<li>${item}</li>`).join('');
        typing?.classList.remove('is-visible');
        if (managerContent) managerContent.hidden = false;
      }, reduceMotion ? 0 : 520);
    }));
  }

  const earlyAccess = document.querySelector('[data-early-access]');
  if (earlyAccess) {
    const choices = earlyAccess.querySelectorAll('[data-role-choice]');
    const groups = earlyAccess.querySelectorAll('[data-role-fields]');
    const syncRole = () => {
      const selected = earlyAccess.querySelector('[data-role-choice]:checked')?.dataset.roleChoice || 'talent';
      groups.forEach((group) => {
        const active = group.dataset.roleFields === selected;
        group.hidden = !active;
        group.querySelectorAll('input,select,textarea').forEach((field) => { field.disabled = !active; });
      });
    };
    choices.forEach((choice) => choice.addEventListener('change', syncRole));
    syncRole();
    const steps = [...earlyAccess.querySelectorAll('[data-form-step]')];
    const progress = earlyAccess.querySelector('[data-form-progress]');
    const stepLabel = earlyAccess.querySelector('[data-step-label]');
    const status = earlyAccess.querySelector('[data-form-status]');
    const formElement = earlyAccess.querySelector('form');
    let currentStep = 1;
    const showStep = (step) => {
      currentStep = Math.max(1, Math.min(steps.length, step));
      steps.forEach((panel) => {
        const active = Number(panel.dataset.formStep) === currentStep;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      progress?.setAttribute('aria-valuenow', String(currentStep));
      progress?.querySelectorAll('i').forEach((item, index) => {
        item.classList.toggle('is-active', index + 1 === currentStep);
        item.classList.toggle('is-complete', index + 1 < currentStep);
      });
      if (stepLabel) stepLabel.textContent = `Step ${currentStep} of ${steps.length}`;
      if (status) status.textContent = '';
      steps[currentStep - 1]?.querySelector('input,select,textarea,button')?.focus({ preventScroll: true });
    };
    const validateCurrentStep = () => {
      const requiredFields = [...(steps[currentStep - 1]?.querySelectorAll('[required]:not(:disabled)') || [])];
      const invalid = requiredFields.find((field) => !field.checkValidity());
      if (!invalid) return true;
      invalid.setAttribute('aria-invalid', 'true');
      if (status) status.textContent = 'Please complete the required field highlighted below.';
      invalid.reportValidity();
      invalid.focus();
      return false;
    };
    earlyAccess.querySelectorAll('[data-step-next]').forEach((button) => button.addEventListener('click', () => {
      if (validateCurrentStep()) showStep(currentStep + 1);
    }));
    earlyAccess.querySelectorAll('[data-step-back]').forEach((button) => button.addEventListener('click', () => showStep(currentStep - 1)));
    earlyAccess.querySelectorAll('input,select,textarea').forEach((field) => field.addEventListener('input', () => field.removeAttribute('aria-invalid')));
    formElement?.addEventListener('invalid', (event) => {
      const field = event.target;
      if (!(field instanceof HTMLElement)) return;
      field.setAttribute('aria-invalid', 'true');
      if (status) status.textContent = 'Please complete the required field highlighted below.';
    }, true);
    if (steps.length) showStep(1);
    const success = earlyAccess.querySelector('.sd-form-success');
    if (success) { success.focus(); success.scrollIntoView({ block: 'center' }); }
  }
})();
